module.exports = __webpack_public_path__ + "static/media/pot-fill.5f24edb4.svg";